module.exports = __webpack_public_path__ + "img/img-1.6f736e86.svg";